import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// css
import { DataGrid } from "@mui/x-data-grid";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import { Link, useNavigate } from "react-router-dom";
import api from "../../../../../utils/apidsf.js";
import { nanoid } from "nanoid";
import swal from "sweetalert";
import LockClockTwoToneIcon from "@mui/icons-material/LockClockTwoTone";
import Tooltip from "@mui/material/Tooltip";

const DictionaryTable = ({ editArticle, forrefresh }) => {
  const navigate = useNavigate();
  const [users, sertusers] = useState([]);
  const [refresh, setrefresh] = useState();

  useEffect(() => {
    try {
      const fetchData = async () => {
        const token = JSON.parse(localStorage.getItem("token"));
        const config = {
          headers: {
            Authorization: token,
          },
        };
        const res = await api.get("/admin/dictionary", config);
        const data = res.data.data;

        const tableData = data.map((w, i) => {
          return {
            id: i + 1,
            dictionaryId: w._id,
            description_hin: w?.description_hin,
            description_eng: w?.description_eng,
            word: w?.word,
            meaning_eng: w?.meaning_eng,
            defination_eng: w?.defination_eng,
            meaning_hin: w?.meaning_hin,
            defination_hin: w?.defination_hin,
            usage_eng: w?.usage_eng,
          };
        });
        sertusers(tableData);
      };
      fetchData();
    } catch (err) {
      console.error(err);
    }
  }, [forrefresh, refresh]);

  const columns = [
    { field: "id", headerName: "ID", width: 20 },
    { field: "word", headerName: "word", width: 50 },
    {
      field: "description_hin",
      headerName: "description_hin",
      sortable: false,
      width: 150,
    },
    {
      field: "meaning_hin",
      headerName: "meaning_hin",
      sortable: false,
      width: 150,
    },
    {
      field: "defination_hin",
      headerName: "defination_hin",
      sortable: false,
      width: 150,
    },
    {
      field: "description_eng",
      headerName: "description_eng",
      sortable: false,
      width: 150,
    },
    {
      field: "meaning_eng",
      headerName: "meaning_eng",
      sortable: false,
      width: 150,
    },
    {
      field: "defination_eng",
      headerName: "defination_eng",
      sortable: false,
      width: 150,
    },
    {
      field: "usage_eng",
      headerName: "usage_eng",
      sortable: false,
      width: 150,
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <>
          <Tooltip title="Set as  Word Of Day" sx={{ cursor: "pointer" }}>
            <LockClockTwoToneIcon
              onClick={async () => {
                let token = JSON.parse(localStorage.getItem("token"));
                const config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                  },
                };

                try {
                  await api.get(
                    `/admin/word-of-day/${params?.row?.dictionaryId}`,
                    config
                  );

                  swal({
                    title: "Success!",
                    text: "Word Of Day Is Set!",
                    icon: "success",
                  });
                } catch (err) {
                  console.log(err);
                  swal({
                    title: "Error!",
                    text: "Something Went Wrong try again",
                    icon: "error",
                  });
                }
              }}
            />
          </Tooltip>
          <button
            className="edit_article_btn"
            onClick={() => {
              navigate(`/admin/create-dictionary/${params?.row?.dictionaryId}`);
            }}
          >
            Edit
          </button>
          <DeleteOutlinedIcon
            onClick={() => {
              let token = JSON.parse(localStorage.getItem("token"));
              const config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: token,
                },
              };

              swal({
                title: "Are you sure?",
                text:
                  "Once deleted, you will not be able to recover this  file!",
                icon: "warning",
                buttons: true,
              }).then(async (willDelete) => {
                if (willDelete) {
                  await api
                    .delete(
                      `/admin/dictionary/${params?.row?.dictionaryId}`,
                      config
                    )
                    .then((res) => {
                      if (res?.data?.success) {
                        swal({
                          title: "Success!",
                          text: "Dictionary Deleted",
                          icon: "success",
                        }).then((value) => {
                          setrefresh(nanoid());
                        });
                      } else {
                        swal({
                          title: "Error!",
                          text: "Try Again",
                          icon: "error",
                        });
                      }
                    })
                    .catch((err) => {
                      swal({
                        title: "Error!",
                        text: "Try Again",
                        icon: "error",
                      });
                    });
                } else {
                  setrefresh(nanoid());
                }
              });
            }}
            className="admin__userListDelete"
          />
        </>
      ),
    },
  ];

  return (
    <div
      style={{
        flex: 4,
      }}
    >
      <DataGrid
        rows={users}
        columns={columns}
        pageSize={30}
        rowsPerPageOptions={[10]}
        disableSelectionOnClick
      />
    </div>
  );
};

export default DictionaryTable;
